import React from "react";
import StatusChip from "../../../common/statusChip/StatusChip";

export function PostStatusChip({ status }) {
  return <StatusChip value={status} />;
}
